import React from "react";
import { Avatar, Tag, Button } from "antd";
import { UserOutlined, LinkOutlined } from "@ant-design/icons";
import { PreviewContainer } from "./style";
import bg_share from "../../assets/bg_share.png";

export default function CoachPreview({
  coachData = {},
  challenges = [],
  onOpenInApp = () => {},
}) {
  const {
    name,
    profile_image,
    socialLink,
    about,
    subscriberCount = 0,
  } = coachData;

  return (
    <PreviewContainer>
      <div className="preview-coach-header">
        <Avatar src={profile_image} icon={<UserOutlined />} size={64} />
        <div className="preview-coach-info">
          <div className="preview-coach-name">{name || "Coach Name"}</div>
          <div
            className="preview-coach-social-link"
            onClick={() => window.open(socialLink, "_blank")}
          >
            <LinkOutlined className="link-icon" />
            <span>{socialLink || "No social link"}</span>
          </div>
          <div className="preview-coach-link">
            {subscriberCount || 0} subscribers
          </div>
        </div>
      </div>
      <div className="preview-about">About</div>
      <div className="preview-coach-description">
        {about || "No description available"}
      </div>
      <Button type="primary" size="large" block onClick={onOpenInApp}>
        Open in the App
      </Button>
      {challenges && challenges.length > 0 && (
        <>
          <div className="preview-about">Challenges</div>
          <div className="preview-coach-challenges">
            {challenges.map((challenge) => (
              <div key={challenge._id} className="preview-challenge-card">
                <Tag className="preview-challenge-tag">
                  {challenge.numberOfDays} days challenge
                </Tag>
                <div className="preview-challenge-title">{challenge.title}</div>
                <img
                  src={bg_share}
                  alt="challenge banner"
                  className="preview-challenge-banner"
                />
                <div className="preview-challenge-description">
                  {challenge.description}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </PreviewContainer>
  );
}
